module.exports = __webpack_public_path__ + "static/media/cinecruise-5.58fc10c0.jpg";